export enum TreeItemMode {
    show,
    edit
}
